
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"eye","fill":"none","stroke":"#6e6e6e","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M13.09 10A3.091 3.091 0 1110 6.909 3.088 3.088 0 0113.09 10z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10 16.78c2.918 0 5.637-1.705 7.53-4.657a4.335 4.335 0 000-4.255C15.637 4.917 12.917 3.212 10 3.212S4.363 4.917 2.47 7.869a4.335 4.335 0 000 4.255C4.363 15.075 7.082 16.78 10 16.78z"}})])])
          )
        }
      }
    